import { render, staticRenderFns } from "./MvProjectOverview.vue?vue&type=template&id=1d53423a&scoped=true&"
import script from "./MvProjectOverview.vue?vue&type=script&lang=js&"
export * from "./MvProjectOverview.vue?vue&type=script&lang=js&"
import style0 from "./MvProjectOverview.vue?vue&type=style&index=0&id=1d53423a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d53423a",
  null
  
)

export default component.exports